import 'babel-polyfill';
import promise from 'es6-promise';
promise.polyfill();

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import element from 'element-ui';
element.Dialog.props.lockScroll.default = false;
import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import uploader from 'vue-simple-uploader'


import AsyncValidator from 'async-validator';

import layer from 'vue-layer';
import login from './components/h-login/index';
import './plugins/element.js';
import 'vue-layer/lib/vue-layer.css';
import 'vue-directive-image-previewer/dist/assets/style.css'
import $ from 'jquery';
import QRCode  from "qrcodejs2";
import axios from 'axios';
Vue.prototype.$axios = axios;
// import Validate from 'vue-validator';
// import VideoPlayer from 'vue-video-player'
// require('video.js/dist/video-js.css')
// require('vue-video-player/src/custom-theme.css')
Vue.use($);
Vue.use(VueDirectiveImagePreviewer) 
// console.log($)
Vue.use(element)
Vue.use(uploader)

import { DatePicker,Pagination  } from 'element-ui'
Vue.component(DatePicker.name, DatePicker)
Vue.component(Pagination .name, Pagination )


Vue.config.productionTip = false;
Vue.prototype.$login = login;
Vue.prototype.$layer = layer(Vue);
Vue.prototype.$validator = AsyncValidator;
Vue.prototype.qrCode
Vue.prototype.$qrCode = QRCode;
// Vue.use(VideoPlayer)

// Vue.use(Validate);

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
